import React from 'react';
import TablerIconSend from '~icons/tabler/send';

export const sendInviteName = 'send';

export type SendInviteIconProps = React.ComponentProps<typeof TablerIconSend>;

export default TablerIconSend;
